export enum SteppedProgressBarTheme {
    PRIMARY = 'primary',
    WHITE = 'white'
}

export interface SteppedProgressBarProps {
    currentStep: number;
    numSteps: number;
    labels?: string[];
    className?: string;
    theme?: SteppedProgressBarTheme;
    showCheckIconForCompletedStep?: boolean;
}